import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { ReactComponent as IncreaseIndentIcon } from 'assets/icons/indentIn24.svg'
import { useIndentInToggle } from 'common/Prose/Toolbar/hooks/useIndentInToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import Styles from '../MobileToolbar.module.scss'

export const IncreaseIndentButton = observer((props: ButtonProps) => {
  const { disabled, handleClick } = useIndentInToggle()

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Increase indentation"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: false,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-increase-indent-mark"
      {...props}
    >
      <IncreaseIndentIcon />
    </Button>
  )
})
